import { AssetAttribute } from "@store";
import { createForm, fields, RdReduxForm, reactBinding, TypedFormBindingTypeConfiguration } from "rd-redux-forms";
import { AssetMap } from "./selector/adUnitAssetSelector";

let currentForms: AssetFormSet | undefined;

export function getCurrentAssetDefForm(): AssetFormSet | undefined {
    return currentForms;
}

export function generateFormsForCurrentAssets(assets: AssetMap) {
    currentForms = {
        main: createFormForAssetDefinition("main", assets.main, false, 0, 0),
        nested: assets.nested.reduce((result, prop) => {
            result[prop.name] = createFormForAssetDefinition(
                prop.name,
                prop.attributes,
                prop.isCollection,
                prop.min,
                prop.max
            );
            return result;
        }, {})
    };
}

function createFormForAssetDefinition(
    name: string,
    assetDef: AssetAttribute[],
    isCollection: boolean,
    min: number,
    max: number
): AssetForm {
    const assetFormFields = assetDef.filter(a => !Array.isArray(a.type)).reduce((r, asset) => {
        if (asset.type === "image" && "min" in asset) {
            r[asset.name] = fields.any();
        } else {
            r[asset.name] = fields.string(true);
        }

        return r;
    }, {});

    const form = createForm(`AD UNIT ASSET BUILDER ${name}`, assetFormFields);

    const bindings = reactBinding()
        .default()
        .withForm(form);

    return {
        form,
        bindings,
        isCollection,
        min,
        max
    };
}

export interface AssetFormSet {
    main: AssetForm;
    nested: {
        [propertyName: string]: AssetForm;
    };
}

export interface AssetForm {
    form: RdReduxForm<any, AssetAttributeFormMeta>;
    bindings: TypedFormBindingTypeConfiguration<any, AssetAttributeFormMeta>;
    isCollection: boolean;
    min: number;
    max: number;
}

export interface AssetAttributeFormMeta {
    formId: string;
    assetPropertyName: string;
    index: number;
}
